import { inpaintTeleaViaWorker } from '~/lib/cv-bridge';
import { useStore } from '~/store';
import { applyClassicalFill } from './classical';

/**
 * Bake the watermark region into the source image. Falls back to the
 * classical fill if the OpenCV worker is unavailable (CDN blocked, init
 * failed, etc.).
 */
export async function applyWatermarkInpaint(): Promise<void> {
  const s = useStore.getState();
  const { region, useOpencv } = s.watermark;
  const imageData = s.source.imageData;
  if (!imageData || !region) return;
  if (!s.source.hash) return;
  try {
    const out = useOpencv
      ? await inpaintTeleaViaWorker(imageData, region, 3)
      : applyClassicalFill(imageData, region);
    s.bakeSourcePixels(out);
  } catch (err) {
    console.error('OpenCV inpaint failed, falling back to classical fill:', err);
    s.bakeSourcePixels(applyClassicalFill(imageData, region));
  }
}
